<template>
    <div class="nav d-flex justify-content-between">
        <button class="btn btn-link" v-if="showBack" @click="handleBack">
            <SvgIcon v-if="backIcon" :name="backIcon" /> {{ backButtonText }}
        </button>
        <button class="btn btn-link" v-if="showSkip" @click="handleSkip">
            {{ skipButtonText }}
            <span class="icon">
                <SvgIcon v-if="forwardIcon" :name="forwardIcon" />
            </span>
        </button>
    </div>
</template>

<script>

import SvgIcon from './SvgIcon.vue';

export default {
    name: 'NavBar',
    components: {
        SvgIcon
    },
    props: {
        showBack: {
            type: Boolean,
            default: true
        },
        showSkip: {
            type: Boolean,
            default: false
        },
        backText: {
            type: String,
            default: null
        },
        backIcon: {
            type: String,
            default: 'back'
        },
        forwardText: {
            type: String,
            default: null
        },
        forwardIcon: {
            type: String,
            default: 'forward'
        }
    },
    methods: {
        handleBack() {
            this.$emit('back');
        },
        handleSkip() {
            this.$emit('skip');
        },
    },
    computed: {
        backButtonText() {
            return this.backText || this.$t('backButtonText');
        },
        skipButtonText() {
            return this.forwardText || this.$t('skipButtonText');
        }
    }
};

</script>
<style scoped>
.btn {
    color: var(--primary-color);
    text-decoration: none;
    font-size: 2.5rem;
    line-height: 3.6373rem;
    font-weight: 700;
}

.svg-icon {
    width: 2.5rem !important;
    height: 2.5rem !important;
    margin-right: 0.5rem;
}

.right {
    float: right;
}
</style>